module.exports = __webpack_public_path__ + "img/9791185676067.2ebecc4c.jpg";